import {i18n} from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function TransmissionChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="transmission"
      label={i18n.t('entity.vehicle.labels.transmission')}
      options={catalogueApi?.transmissionOptions ?? []}
      isDeselectable
    />
  );
}
